const DEFAULT_EXTENSIONS = [
  'jpeg',
  'jpg',
  'png',
]

export default {
  value: {
    type: [ Object, String ],
    default: () => null,
  },

  buttonText: {
    type: String,
    default: () => 'Adicionar',
  },

  placeholder: {
    type: String,
    default: () => 'Selecione um arquivo.'
  },

  /**
    * Allowed file extensions (preferably in lowercase)
    */
  extensions: {
    type: Array,
    default: () => DEFAULT_EXTENSIONS
  },

  /**
    * File size limit in the selected unit (megabyte by default)
    */
  sizeLimit: {
    type: [ Number, String ],
    default: 8,
    validator: v => Number(v) > 0 // valid number
  },

  width: {
    type: Number,
    default: () => 400
  },

  height: {
    type: Number,
    default: () => 248
  },

  errors: {
    type: Array,
    default: () => ([])
  },

  hideIconButton: {
    type: Boolean,
    default: false
  },

  alternativeEmptyState: {
    type: Boolean,
    default: false
  },

  dashed: {
    type: Boolean,
    default: true
  },

  addDisabled: {
    type: Boolean,
    default: false
  },

  emptyStateText: {
    type: String,
    default: ''
  },

  characterType: {
    type: String,
    default: 'photo'
  },

  addIcon: {
    type: [ String, null ],
    default: null
  },

  addWidth: {
    type: Number,
    default: 180
  },

  warningMessage: {
    type: [ String, null ],
    default: null
  },
}
